// src/components/CommonHeader.jsx
import React, { useState } from 'react';
import './CommonHeader.css';
import config from '../config';
import logo from '../logo.svg';

const CommonHeader = ({
  activePage,
  onNavigate,
  onLogin,
  onSignup,
  onBlogClick
}) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavClick = (e, page) => {
    e.preventDefault();
    setMenuOpen(false);
    if (onNavigate) onNavigate(page);
  };

  const handleLogin = () => {
    setMenuOpen(false);
    if (onLogin) onLogin();
  };

  const handleSignup = () => {
    setMenuOpen(false);
    if (onSignup) onSignup();
  };

  return (
    <>
      <header className="common-header">
        <div className="container">
          {/* Logo */}
          <div
            className="logo"
            onClick={() => { setMenuOpen(false); onNavigate && onNavigate('home'); }}
          >
            <img
              src={logo}
              alt={`${config.APP_NAME} Logo`}
              className="logo-icon"
              width="45"
              height="45"
            />
            <span className="logo-text">{config.APP_NAME}</span>
          </div>

          {/* Desktop nav */}
          <nav className="nav-links desktop-nav">
            <button
              className={`nav-link ${activePage === 'home' ? 'active' : ''}`}
              onClick={(e) => handleNavClick(e, 'home')}
            >
              Home
            </button>
            {activePage !== 'landing' && (
              <>
                <button
                  className={`nav-link ${activePage === 'features' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'features')}
                >
                  Features
                </button>
                <button
                  className={`nav-link ${activePage === 'how-it-works' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'how-it-works')}
                >
                  How It Works
                </button>
                <button
                  className={`nav-link ${activePage === 'pricing' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'pricing')}
                >
                  Pricing
                </button>
              </>
            )}
            <button
              className={`nav-link ${activePage === 'blog' ? 'active' : ''}`}
              onClick={(e) => handleNavClick(e, 'blog')}
            >
              Blog
            </button>
            <button onClick={handleLogin} className="btn-login">Login</button>
            <button onClick={handleSignup} className="btn-signup">Sign Up</button>
          </nav>

          {/* Hamburger — mobile only */}
          <button
            className={`mobile-menu-btn ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="Toggle navigation menu"
            aria-expanded={menuOpen}
          >
            <span className="hamburger-bar" />
            <span className="hamburger-bar" />
            <span className="hamburger-bar" />
          </button>
        </div>
      </header>

      {/* Mobile drawer — rendered OUTSIDE header so it's never clipped */}
      <div className={`mobile-drawer ${menuOpen ? 'open' : ''}`}>
        <nav className="mobile-nav">
          <button
            className={`nav-link ${activePage === 'home' ? 'active' : ''}`}
            onClick={(e) => handleNavClick(e, 'home')}
          >
            Home
          </button>
          {activePage !== 'landing' && (
            <>
              <button
                className={`nav-link ${activePage === 'features' ? 'active' : ''}`}
                onClick={(e) => handleNavClick(e, 'features')}
              >
                Features
              </button>
              <button
                className={`nav-link ${activePage === 'how-it-works' ? 'active' : ''}`}
                onClick={(e) => handleNavClick(e, 'how-it-works')}
              >
                How It Works
              </button>
              <button
                className={`nav-link ${activePage === 'pricing' ? 'active' : ''}`}
                onClick={(e) => handleNavClick(e, 'pricing')}
              >
                Pricing
              </button>
            </>
          )}
          <button
            className={`nav-link ${activePage === 'blog' ? 'active' : ''}`}
            onClick={(e) => handleNavClick(e, 'blog')}
          >
            Blog
          </button>

          <div className="mobile-auth-btns">
            <button onClick={handleLogin} className="btn-login">Login</button>
            <button onClick={handleSignup} className="btn-signup">Sign Up</button>
          </div>
        </nav>
      </div>

      {/* Backdrop */}
      {menuOpen && (
        <div className="mobile-backdrop" onClick={() => setMenuOpen(false)} />
      )}
    </>
  );
};

export default CommonHeader;